import { useMutation } from '@tanstack/react-query'
import { ContentAnalysisApiService } from 'src/services/contentAnalysisApi'

export interface ExportContentAnalysisPostsParams {
  fromDate?: string
  id: string
  platform?: string
  toDate?: string
}

const exportContentAnalysisPosts = ({
  fromDate,
  id,
  platform,
  toDate,
}: ExportContentAnalysisPostsParams): Promise<Blob> =>
  ContentAnalysisApiService.exportPosts(id, { fromDate, platform, toDate })

export const useExportContentAnalysisPostsMutation = () =>
  useMutation({
    mutationFn: exportContentAnalysisPosts,
  })
